import { Dispatch, FC } from 'react';
import { Provider } from 'react-redux';
import { Router } from 'react-router-dom';

import ErrorBoundary from 'components/ErrorBoundary/ErrorBoundary';
import Main from 'components/Main/Main';
import Modal from 'components/Modal/ModalComponent';
import UserLoader from 'components/UserLoader/UserLoader';
import configureStore from 'store/configureStore';
import { withNetworkStatus } from 'hocs/withNetworkStatus';
import WithTheme from 'hocs/WithTheme';
import history from 'utils/history';

export const store = configureStore();

export type RootState = ReturnType<typeof store.getState>;
export type GetRootState = typeof store.getState;
export type AppDispatch = typeof store.dispatch | Dispatch<any>;

const Notifications = () => <div id="notifications" />;

const App: FC = () =>
  <ErrorBoundary>
    <Provider store={store}>
      <Router history={history}>
        <WithTheme>
          <Notifications />
          <UserLoader />
          <Main />
          <Modal />
        </WithTheme>
      </Router>
    </Provider>
  </ErrorBoundary>;

export default withNetworkStatus(App);
